import { useParams, useSearchParams } from "react-router-dom"
import TourCard from "../../components/cards/TourCard"
import HomeSearch from "../../components/elements/HomeSearch"
import useWidth from "../../hooks/useWidth"
import Navbar from "../../layout/Navbar"

import MobileHeader from "../../layout/MobileHeader"
import MobileHeaderSearch from "../../components/MobileHeaderSearch"
import { useFetch } from "../../hooks/useFetch"
import { getToursAndEvents } from "../../apis"
import { useMemo } from "react"
import Loader from "../../components/elements/Loader"

export default () => {
    const width = useWidth()
    const params = useParams()
    const searchParams = useSearchParams();

    const categoryId = searchParams[0].get("categoryId");
    const search = searchParams[0].get("search");

    const [toursAndEvents,,loading] = useFetch(getToursAndEvents, {}, search )
    const categoryList = useMemo(() =>  toursAndEvents.allEventsTours?.filter( t => search || t.type === categoryId ), [ toursAndEvents ])


    return (
        <>
        <Loader loading={loading} />
            {
                width > 992 ?
                    <>
                        <Navbar gradient />
                        <section className="desktop-top-space">
                            <div className="d-flex justify-content-center flex-column align-items-center guide-page-title ">
                                <p className="custom-text-color xx-bold text-center  fs-1 ">Search Results</p>
                                <HomeSearch placeholder={"Search Tour & Events"} />
                            </div>
                        </section>
                    </>
                    :
                    <MobileHeader>
                        <MobileHeaderSearch placeholder="Search Tour & Events" />
                    </MobileHeader>

            }


            <section className="mobile-top-space container">
                <h4 className="container ">{ search ? `Search: ${ search }` : ( categoryId === "tour" ? "All Tours" : "All Events" )}</h4>
                <div className="row m-0 p-0">
                    {
                        categoryList?.map(( data, i ) =>
                            <div className="col-lg-4" key={i}>
                                <div className="my-2">
                                    <TourCard data={data}/>
                                </div>
                            </div>
                        )
                    }
                </div>
            </section>




        </>
    )
}